export const proposalFont =
  '"DM Sans", "Helvetica Neue", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif';

export const proposalDisplay =
  '"Fraunces", "Iowan Old Style", "Palatino Linotype", Palatino, Georgia, serif';

export const proposalTokens = {
  bg: "#0c0b0a",
  bgElevated: "#161412",
  bgSoft: "#1c1916",
  text: "#f4f0ea",
  textMuted: "rgba(244, 240, 234, 0.68)",
  textFaint: "rgba(244, 240, 234, 0.45)",
  accent: "#c4a574",
  accentSoft: "rgba(196, 165, 116, 0.18)",
  border: "rgba(244, 240, 234, 0.12)",
  warm: "#e8dcc8",
  maxWidth: 1120,
} as const;

export const PROPOSAL_FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,400;0,9..40,500;0,9..40,600;0,9..40,700;1,9..40,400&family=Fraunces:opsz,wght@9..144,400;9..144,500;9..144,600;9..144,700&display=swap";
